/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.establishment.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../validate/validate_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var witbooking_backoffice_common_common_pb = require('../../../../witbooking/backoffice/common/common_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.establishment = {};
proto.witbooking.backoffice.establishment.v1 = require('./establishment_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.establishment.v1.EstablishmentAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.establishment.v1.EstablishmentAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.establishment.v1.GetPropertyRequest,
 *   !proto.witbooking.backoffice.establishment.v1.GetPropertyResponse>}
 */
const methodDescriptor_EstablishmentAPI_GetProperty = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.establishment.v1.EstablishmentAPI/GetProperty',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.establishment.v1.GetPropertyRequest,
  proto.witbooking.backoffice.establishment.v1.GetPropertyResponse,
  /**
   * @param {!proto.witbooking.backoffice.establishment.v1.GetPropertyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.establishment.v1.GetPropertyResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.establishment.v1.GetPropertyRequest,
 *   !proto.witbooking.backoffice.establishment.v1.GetPropertyResponse>}
 */
const methodInfo_EstablishmentAPI_GetProperty = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.establishment.v1.GetPropertyResponse,
  /**
   * @param {!proto.witbooking.backoffice.establishment.v1.GetPropertyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.establishment.v1.GetPropertyResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.establishment.v1.GetPropertyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.establishment.v1.GetPropertyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.establishment.v1.GetPropertyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.establishment.v1.EstablishmentAPIClient.prototype.getProperty =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.establishment.v1.EstablishmentAPI/GetProperty',
      request,
      metadata || {},
      methodDescriptor_EstablishmentAPI_GetProperty,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.establishment.v1.GetPropertyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.establishment.v1.GetPropertyResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.establishment.v1.EstablishmentAPIPromiseClient.prototype.getProperty =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.establishment.v1.EstablishmentAPI/GetProperty',
      request,
      metadata || {},
      methodDescriptor_EstablishmentAPI_GetProperty);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.establishment.v1.UpdatePropertyRequest,
 *   !proto.witbooking.backoffice.establishment.v1.UpdatePropertyResponse>}
 */
const methodDescriptor_EstablishmentAPI_UpdateProperty = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.establishment.v1.EstablishmentAPI/UpdateProperty',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.establishment.v1.UpdatePropertyRequest,
  proto.witbooking.backoffice.establishment.v1.UpdatePropertyResponse,
  /**
   * @param {!proto.witbooking.backoffice.establishment.v1.UpdatePropertyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.establishment.v1.UpdatePropertyResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.establishment.v1.UpdatePropertyRequest,
 *   !proto.witbooking.backoffice.establishment.v1.UpdatePropertyResponse>}
 */
const methodInfo_EstablishmentAPI_UpdateProperty = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.establishment.v1.UpdatePropertyResponse,
  /**
   * @param {!proto.witbooking.backoffice.establishment.v1.UpdatePropertyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.establishment.v1.UpdatePropertyResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.establishment.v1.UpdatePropertyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.establishment.v1.UpdatePropertyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.establishment.v1.UpdatePropertyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.establishment.v1.EstablishmentAPIClient.prototype.updateProperty =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.establishment.v1.EstablishmentAPI/UpdateProperty',
      request,
      metadata || {},
      methodDescriptor_EstablishmentAPI_UpdateProperty,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.establishment.v1.UpdatePropertyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.establishment.v1.UpdatePropertyResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.establishment.v1.EstablishmentAPIPromiseClient.prototype.updateProperty =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.establishment.v1.EstablishmentAPI/UpdateProperty',
      request,
      metadata || {},
      methodDescriptor_EstablishmentAPI_UpdateProperty);
};


module.exports = proto.witbooking.backoffice.establishment.v1;

